/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Intended_EndInputs */

const en_consumer_declaration_intended_end = /** @type {(inputs: Consumer_Declaration_Intended_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intended end date`)
};

const de_consumer_declaration_intended_end = /** @type {(inputs: Consumer_Declaration_Intended_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewünschter Beendigungszeitpunkt`)
};

const fr_consumer_declaration_intended_end = /** @type {(inputs: Consumer_Declaration_Intended_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de fin souhaitée`)
};

const es_consumer_declaration_intended_end = /** @type {(inputs: Consumer_Declaration_Intended_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de finalización deseada`)
};

const it_consumer_declaration_intended_end = /** @type {(inputs: Consumer_Declaration_Intended_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data di fine desiderata`)
};

const nl_consumer_declaration_intended_end = /** @type {(inputs: Consumer_Declaration_Intended_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewenste einddatum`)
};

const pl_consumer_declaration_intended_end = /** @type {(inputs: Consumer_Declaration_Intended_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Żądany termin zakończenia`)
};

const fi_consumer_declaration_intended_end = /** @type {(inputs: Consumer_Declaration_Intended_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toivottu päättymispäivä`)
};

const da_consumer_declaration_intended_end = /** @type {(inputs: Consumer_Declaration_Intended_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ønsket slutdato`)
};

const sv_consumer_declaration_intended_end = /** @type {(inputs: Consumer_Declaration_Intended_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önskat slutdatum`)
};

/**
* | output |
* | --- |
* | "Intended end date" |
*
* @param {Consumer_Declaration_Intended_EndInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_intended_end = /** @type {((inputs?: Consumer_Declaration_Intended_EndInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Intended_EndInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_intended_end(inputs)
	if (locale === "fr") return fr_consumer_declaration_intended_end(inputs)
	if (locale === "es") return es_consumer_declaration_intended_end(inputs)
	if (locale === "it") return it_consumer_declaration_intended_end(inputs)
	if (locale === "nl") return nl_consumer_declaration_intended_end(inputs)
	if (locale === "pl") return pl_consumer_declaration_intended_end(inputs)
	if (locale === "fi") return fi_consumer_declaration_intended_end(inputs)
	if (locale === "da") return da_consumer_declaration_intended_end(inputs)
	if (locale === "sv") return sv_consumer_declaration_intended_end(inputs)
	return en_consumer_declaration_intended_end(inputs)
});